import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <>
            <nav className="navbar navbar-expand-lg bg-light footer" >
                <div className="container-fluid">
                    <span>Design and Develop by (with references) KANAK SINGHAL</span>
                    
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="#" target={"_blank"}>
                                    <img src="https://www.freepnglogos.com/uploads/logo-ig-png/logo-ig-stunning-instagram-logo-vector-download-for-new-7.png" alt="" width="30" height="24"></img>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#" target={"_blank"}>
                                    <img src="https://cdn-icons-png.flaticon.com/512/124/124010.png" alt="" width="30" height="24"></img>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://www.linkedin.com/in/kanak-singhal-206bb720b" target="_blank">
                                    <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="" width="30" height="24"></img>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://github.com/Kanaksinghal26" target={"_blank"}>
                                    <img src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="" width="30" height="24"></img>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Footer

